<template>
  <div>
    <transition name="slide">
      <div v-show="isVisible">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'redux-vuex';
import select from '@/store/selectors';

export default {
  data: mapState({
    isVisible: select.components.extendedBlock,
  }),
};

</script>

<style lang="postcss" scoped>
.slide-enter-active {
  transition: max-height .3s ease-in-out;
}

.slide-leave-active {
  transition: max-height .3s cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 1000px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
